hubsTestActive